import bgImage from "../images/afro-solar/remote-monitoring/bg.webp";

const RemoteMonitoring = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
      }}
      id="remote-monitoring"
    >
      <div className="row">
        <div className="col-12 col-md-6 p-4 bg-american-yellow remote-monitoring-clip-path">
          <div className="w-75 py-5">
            <h2 className="fs-56 gilroy-bold">REMOTE MONITORING</h2>
            <p className="fs-16 lh-30">
              Afro Solar can design, develop and deliver state-of-the-art NOC
              (Network Operating System) centers across the world.{" "}
            </p>
            <ul className="fs-16 lh-30">
              <li>
                The system enables remote monitoring and management of solar
                rooftop systems
              </li>
              <li>Highly configurable performance monitoring</li>
              <li>Live data tracking and analysis</li>
              <li>
                An opportunity for proactive maintenance and support, ensuring
                maximum plant uptime
              </li>
              <li>User get real-time access to their plant performance</li>
              <li>Notification and Service Intervention Alarms</li>
            </ul>
            <p className="fs-16 mt-5 lh-30">
              ​ The center gives an edge in monitoring operations & managing
              maintenance of all connected sites, providing instant insights and
              real-time proactive action – ensuring maximum generation & uptime.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemoteMonitoring;
